import React from "react";
import customeI from '../../images/home/custom-software.png';

function CustomSoftware() {
  return (
    <>

      <section
        className="service-page-hero"
        style={{ backgroundColor: '#002952' }}
      >
        <div className="container">
          <div className="service-hero-content">

            <h1>Custom Software Development</h1>
            <p style={{ color: '#FF7D37' }}>
              Software solutions designed around<br /> business processes,
              requirements, and long-term goals.
            </p>
          </div>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={customeI}
                alt="Custom Software Development"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Software That Works The Way Your Business Works</h2>

                <p>
                  Every business has different processes and requirements.
                  Instead of forcing your business to adapt to generic
                  software, we develop solutions around your actual workflow.
                </p>

                <p>
                  From small internal applications to complete business
                  management systems, we build software that can grow with
                  your organization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Custom Software Solutions</h2>
          </div>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="service-feature-card">
                <h3>Business Applications</h3>
                <p>
                  Applications designed to simplify your daily business
                  operations and workflows.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="service-feature-card">
                <h3>Process Automation</h3>
                <p>
                  Reduce repetitive manual work by automating important
                  business processes.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="service-feature-card">
                <h3>Scalable Solutions</h3>
                <p>
                  Software designed to support your business as your users,
                  data, and requirements grow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ServiceCTA />
    </>
  );
}

function ServiceCTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>START YOUR PROJECT</span>
            <h2>Have A Software Idea?</h2>
            <p>
              Tell us about your requirements and let's build the right
              solution for your business.
            </p>
          </div>

          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default CustomSoftware;